<template>
  <div class="profile-page">
    <div class="page-header teios-header" style="background-image: url('../img/presskit/Presskit_header.jpg');"  filter-color="blue">       
      <div class=" presskit-header container">
        <div class="content-top brand">
          <img src="img/presskit/logos/teios-main-logo.png" alt="Game Image 1" class="game-logo" />
          <h3>ACTION-ADVENTURE INDIE GAME IN DEVELOPMENT</h3>
        </div>
      </div>
    </div>
    <div class="main main-container">      
       <div class="container">
        <div class="section-presskit-overview row">
          <div class="col-md-4 text-left color-black">
            <h3>Factsheet</h3>
            <dl class="factsheet-list">
              <div class="fact-item">
                <dt>Title:</dt>
                <dd>Teios Journey</dd>
              </div>
              <div class="fact-item">
                <dt>Genre:</dt>
                <dd>Action-Adventure</dd>
              </div>
              <div class="fact-item">
                <dt>Platform:</dt>
                <dd>Steam, Consoles</dd>
              </div>
              <div class="fact-item">
                <dt>Release date:</dt>
                <dd>To be announced</dd>
              </div>
              <div class="fact-item">
                <dt>Developer:</dt>
                <dd>Serendipia Games</dd>
              </div>
              <div class="fact-item">
                <dt>Publisher:</dt>
                <dd>-</dd>
              </div>
              <div class="fact-item email">
                <dt>Contact:</dt>
                <dd><a href="mailto:info@serendipiagames.com">info@serendipiagames.com</a></dd>
              </div>
              <div class="fact-item">
                <dt>Youtube:</dt>
                <dd><a href="https://www.youtube.com/@SerendipiaGames">Serendipia</a></dd>
              </div>
              <div class="fact-item">
                <dt>Instagram:</dt>
                <dd><a href="https://www.instagram.com/serendipiagames">@serendipiagames</a></dd>
              </div>
              <div class="fact-item">
                <dt>Twitter / X:</dt>
                <dd><a href="https://x.com/Serendipiagame">serendipiagames</a></dd>
              </div>
              <div class="fact-item">
                <dt>Steam</dt>
                <dd><a href="https://store.steampowered.com/app/3506070/Teios_Journey/">Teios Journey</a></dd>
              </div>

              <div class="fact-item">
                <dt>TikTok</dt>
                <dd><a href="https://www.tiktok.com/@serendipiagames">@serendipiagames</a></dd>
              </div>

              <div class="fact-item">
                <dt>Address:</dt>
                <dd>132 bis N° 524, City Bell, Buenos Aires, Argentina</dd>
              </div>
            </dl>
          </div>

          <div class="col-8 col-md-8 text-left color-black">
            <h3>Description</h3>
            <div class="game-description">
              <p>
                <strong>Teios Journey</strong> is an action-adventure game created by Santiago Lozano and Marcelo Navarro. It 
                takes players on a thrilling journey through a vibrant world
                filled with challenges and mysteries. Explore diverse
                environments, solve puzzles, and engage in combat to uncover the
                secrets of the land.
              </p>
              <a class="btn btn-info" href="https://drive.google.com/drive/u/2/folders/1as1gPrG90Knr9yUGhzHmLZMR1RuRG5pu">DOWNLOAD ASSETS</a>
            </div>
          </div>
        </div>
        
        <div class="section-presskit-overview row">
          <div class="col-12 col-md-12 text-left color-black">
            <h3>GAME FEATURES</h3>
            <p>
              <b>Innovative physics-based gameplay</b> – Solve puzzles
              creatively using your own ideas and creations. Use tools, objects,
              and abilities to overcome challenges with multiple solutions.
            </p>
            <p>
              <b>Co-op mode</b> – Play with a friend on the same screen. Your
              partner can join or leave at any time, sharing the adventure and
              solving puzzles together.
            </p>
            <p>
              <b>Challenging combat</b> – Battle beasts, golems, monsters,
              mercenaries, and powerful bosses that will test your skills.
            </p>

            <p>
              <b>Explore forbidden temples</b> – Discover ancient artifacts and
              relics, and combine them to create unique summons and tools.
            </p>

            <p>
              <b>A dynamic and living world</b> – Travel through diverse
              regions, each with its own cultures and traditions. Listen to the
              stories every village has to tell.
            </p>

            <p>
              <b>Epic journeys and survival</b> – Unlock new paths between
              regions. Camp in the desert, sleep in mountain caves, or anchor
              your boat on the way to lost islands. Learn to enjoy the nights
              under the moon.
            </p>

            <p>
              <b>Legendary quests</b> – Find lost relics, help wanderers on your
              path, and earn valuable rewards.
            </p>
            <div class="features-image">
              
            </div>
            <p class="features-cta">Are you ready to forge your own legend?</p>
          </div>
        </div>
        <div class="align-center">
          <h3>Trailer</h3>
          <iframe class="iframe-youtube" src="https://www.youtube.com/embed/CpHJR2DNm1c?autoplay=1" width="960" height="540" allow="autoplay"></iframe>          
        </div>
        <div class="section-presskit-overview">
          <h3>Logo - Icons</h3>
        <div class="col-md-12 text-left color-black row">
          
          <div class="col-md-6 ">
              <img src="img/presskit/logos/teios-main-logo.png" alt="Game Image 1" class="game-logo" />
              <img src="img/presskit/logos/serendipia_logo_square_t.png" alt="Game Image 1" class="game-logo" />
              <img src="img/presskit/logos/serendipia_logo_square_dark_t.png" alt="Game Image 1" class="game-logo" />
              
          </div>
          <div class="col-md-6 ">            
              <img src="img/presskit/logos/serendipia_logo_horizontal_t.png" alt="Game Image 1" class="game-logo" />
              <img src="img/presskit/logos/serendipia_logo_horizontal_td.png" alt="Game Image 1" class="game-logo" />
            
          </div>
          </div>
        </div>

        <div class="section-presskit-overview row">
          <h3>Cover</h3>
          <div class="text-left color-black row">
            <div class="col-12">
              <img src="img/presskit/cover/TeiosCoverCamp.jpg" alt="TeiosCoverCamp" class="game-image"/>
              <img src="img/presskit/cover/TeiosCoverSteam.jpg" alt="TeiosCoverSteam" class="game-image"/>
              <img src="img/presskit/cover/TeiosCoverAlone.png" alt="TeiosCoverAlone" class="game-image"/>
              <img src="img/presskit/cover/TeiosCoverDesert.jpg" alt="TeiosCoverDesert" class="game-image"/>
            </div>
          </div>
        </div>

        <div class="section-presskit-overview row">
          <h3>Gameplay</h3>
          <div class="text-left color-black row">
            <div class="col-12">
              <!--img src="img/presskit/screenshots/teios_journey_1.png" alt="Game Image 1" class="game-image" /-->
              <img src="img/presskit/screenshots/teios_journey_2.png" alt="Game Image 2" class="game-image"/>
              <img src="img/presskit/screenshots/teios_journey_3.png" alt="Game Image 2" class="game-image"/>
              <img src="img/presskit/screenshots/teios_journey_4.png" alt="Game Image 2" class="game-image"/>
              <!--img src="img/presskit/screenshots/teios_journey_5.png" alt="Game Image 2" class="game-image"/-->
              <img src="img/presskit/screenshots/teios_journey_6.png" alt="Game Image 2" class="game-image"/>
              <img src="img/presskit/screenshots/teios_journey_7.png" alt="Game Image 2" class="game-image"/>
              <img src="img/presskit/screenshots/teios_journey_8.png" alt="Game Image 2" class="game-image"/>
              <img src="img/presskit/screenshots/teios_journey_9.png" alt="Game Image 1" class="game-image" />
              <!--img src="img/presskit/screenshots/teios_journey_10.png" alt="Game Image 1" class="game-image" /-->
              <img src="img/presskit/screenshots/teios_journey_11.png" alt="Game Image 1" class="game-image" />
              <img src="img/presskit/screenshots/teios_journey_12.png" alt="Game Image 1" class="game-image" />
              <img src="img/presskit/screenshots/teios_journey_13.png" alt="Game Image 1" class="game-image" />
              
            </div>
          </div>
        </div>

        <div class="section-presskit-overview">
          <h3>Gif</h3>
          <div class="col-md-6 ">            
              <img src="img/presskit/screenshots/teios_1.gif" alt="Game Image 1" class="game-gif" />
              <img src="img/presskit/screenshots/teios_2.gif" alt="Game Image 2" class="game-gif" />
              <img src="img/presskit/screenshots/teios_3.gif" alt="Game Image 3" class="game-gif" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  bodyClass: "index-page",
  components: {},
};
</script>
<style scoped>
.factsheet-list {
  margin: 0;
  padding: 0;
}
.fact-item {
  display: flex;
  margin-bottom: 8px;
}
.fact-item dt {
  min-width: 130px;
  font-weight: bold;
  margin-right: 10px;
}
.fact-item dd {
  margin: 0;
}

.game-gif {
  max-height: 300px;
  text-align: center !important; 
  -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    border-radius: 20px;
    margin: 10px;
}

.game-logo {
  max-height: 200px;
  text-align: center !important; 
  -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    border-radius: 20px;
}

.teios-header { 
  background-position-y: center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
}

.presskit-header {
  padding-top: 40px !important;
}

.section-presskit-overview {
  padding: 30px 0;
}

.game-image {
  max-width: 50%;
    height: auto;
    padding: 10px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    border-radius: 20px;
}


.iframe-container {
    display: flex;
    justify-content: center;
}
    
.iframe-youtube {
    aspect-ratio: 16 / 9;
    width: 100% !important;
    height: auto;
}

.main-container{
  background-color: #1e1e1e;
}

.main-container{
  background-color: #1e1e1e;
  color: #f2ebeb !important;
}

</style>
